import React from 'react';
import { RotateCcwIcon, XIcon } from 'lucide-react';
import { useStudio } from '../../contexts/StudioContext';
import { weekdayLabels } from '../../data/schedule';
import { longDate } from '../../utils/format';
export function AvailabilityAdmin() {
  const {
    settings,
    updateSettings,
    toggleBlockedDate,
    resetDemoData
  } = useStudio();
  const input = 'rounded-xl border border-edge bg-panel px-3.5 py-2.5 text-sm text-chalk focus:border-ember';
  const setHours = (index: number, patch: {
    open?: string | null;
    close?: string | null;
  }) => {
    const hours = settings.hours.map((h, i) => i === index ? {
      ...h,
      ...patch
    } : h);
    updateSettings({
      hours
    });
  };
  const order = [1, 2, 3, 4, 5, 6, 0];
  return <div className="w-full max-w-full px-4 py-5 lg:px-8 lg:py-8" data-id="element-810" data-mp="xgovnmkhyeec">
      <header className="flex flex-wrap items-end justify-between gap-4" data-id="element-811" data-mp="1uwvodj1or7ye">
        <div data-id="element-812" data-mp="1uz8c6cu4kcjd">
          <h1 className="hidden font-display text-2xl font-extrabold tracking-tightest text-chalk lg:block lg:text-3xl" data-id="element-813" data-mp="1q6fc429lpsdm">
            Beschikbaarheid
          </h1>
          <p className="text-sm text-dim lg:mt-1.5" data-id="element-814" data-mp="1codmw1ji4t1r">
            Openingstijden, capaciteit en aanbetaling bepalen wat klanten online kunnen kiezen.
          </p>
        </div>
        <button type="button" onClick={resetDemoData} className="inline-flex items-center gap-2 rounded-full border border-edge px-5 py-2.5 text-sm text-dim transition-colors duration-200 ease-smooth hover:border-ember hover:text-ember" data-id="element-815" data-mp="13uh7r6or8gvu">
          <RotateCcwIcon className="h-4 w-4" aria-hidden="true" data-id="element-816" data-mp="ywyux57m9hik" />
          Demodata herstellen
        </button>
      </header>

      <div className="mt-7 grid grid-cols-1 gap-6 xl:grid-cols-[minmax(0,1fr)_minmax(0,380px)]" data-id="element-817" data-mp="kxzgeqdtij04">
        <section className="rounded-2xl border border-edge bg-carbon" data-id="element-818" data-mp="oz15wfhxngow">
          <h2 className="border-b border-edge px-5 py-4 text-xs uppercase tracking-[0.2em] text-dim" data-id="element-819" data-mp="2fa5upy20dfwn">
            Openingstijden
          </h2>
          <ul className="divide-y divide-edge" data-id="element-820" data-mp="2jbhlw80j696y">
            {order.map(index => {
            const hours = settings.hours[index];
            const closed = !hours.open || !hours.close;
            return <li key={index} className="flex flex-wrap items-center gap-3 px-4 py-4 lg:px-5" data-id="element-821" data-mp="3nch91kh4iwnr">
                  <span className="w-24 shrink-0 text-sm capitalize text-chalk lg:w-28" data-id="element-822" data-mp="3jandfqlsciug">
                    {weekdayLabels[index]}
                  </span>
                  <label className="flex items-center gap-2 text-xs text-dim" data-id="element-823" data-mp="et9ozu2e75xo">
                    <input type="checkbox" checked={!closed} onChange={e => setHours(index, e.target.checked ? {
                  open: '09:00',
                  close: '18:00'
                } : {
                  open: null,
                  close: null
                })} className="h-4 w-4 accent-[#ff6a2b]" data-id="element-824" data-mp="as7q5ece0vw8" />
                    Open
                  </label>
                  {!closed && <span className="flex min-w-0 flex-1 items-center gap-2" data-id="element-825" data-mp="114b3z7kw54b9">
                      <label className="sr-only" htmlFor={`open-${index}`} data-id="element-826" data-mp="162w1gz8rd9w0">
                        Openingstijd {weekdayLabels[index]}
                      </label>
                      <input id={`open-${index}`} type="time" value={hours.open ?? ''} onChange={e => setHours(index, {
                  open: e.target.value
                })} className={`min-w-0 flex-1 ${input}`} data-id="element-827" data-mp="1f29fm57tumn2" />
                      <span className="text-dim" data-id="element-828" data-mp="1tsgmrosdwj8g">—</span>
                      <label className="sr-only" htmlFor={`close-${index}`} data-id="element-829" data-mp="1yqiib96zyb0t">
                        Sluitingstijd {weekdayLabels[index]}
                      </label>
                      <input id={`close-${index}`} type="time" value={hours.close ?? ''} onChange={e => setHours(index, {
                  close: e.target.value
                })} className={`min-w-0 flex-1 ${input}`} data-id="element-830" data-mp="22toiq07fh7zd" />
                    </span>}
                </li>;
          })}
          </ul>
        </section>

        <div className="space-y-6" data-id="element-831" data-mp="1yuobaibxdq5x">
          <section className="rounded-2xl border border-edge bg-carbon p-5" data-id="element-832" data-mp="1yvpvpdetzp0b">
            <h2 className="text-xs uppercase tracking-[0.2em] text-dim" data-id="element-833" data-mp="1b6n3xcqhgfs3">Planning</h2>
            <div className="mt-4 space-y-4" data-id="element-834" data-mp="174s5qh3umiij">
              <div data-id="element-835" data-mp="175tgekgyd2zq">
                <label htmlFor="bays" className="text-sm font-medium text-chalk" data-id="element-836" data-mp="176cx5xuv9lc6">
                  Voertuigen tegelijk ({settings.bays})
                </label>
                <input id="bays" type="range" min={1} max={4} value={settings.bays} onChange={e => updateSettings({
                bays: Number(e.target.value)
              })} className="mt-3 w-full accent-[#ff6a2b]" data-id="element-837" data-mp="1g33tmbdbz27a" />
              </div>
              <div data-id="element-838" data-mp="iaxde6rhy3v4">
                <label htmlFor="lead" className="text-sm font-medium text-chalk" data-id="element-839" data-mp="ic8jwecbtppx">
                  Minimale voorlooptijd ({settings.leadTimeHours} uur)
                </label>
                <input id="lead" type="range" min={0} max={72} step={4} value={settings.leadTimeHours} onChange={e => updateSettings({
                leadTimeHours: Number(e.target.value)
              })} className="mt-3 w-full accent-[#ff6a2b]" data-id="element-840" data-mp="9a7qxto4lpu2" />
              </div>
              <div data-id="element-841" data-mp="s8tpp1w674ut">
                <label htmlFor="step" className="text-sm font-medium text-chalk" data-id="element-842" data-mp="s8bl9hzctkbt">
                  Startmomenten per
                </label>
                <select id="step" value={settings.slotStepMinutes} onChange={e => updateSettings({
                slotStepMinutes: Number(e.target.value)
              })} className={`mt-2 w-full ${input}`} data-id="element-843" data-mp="1fwuuq0u5435h">
                  <option value={30} data-id="element-844" data-mp="1pnuykafhtjku">30 minuten</option>
                  <option value={60} data-id="element-845" data-mp="1kn6zr2l0vyg2">60 minuten</option>
                  <option value={90} data-id="element-846" data-mp="1klm3n8j287g3">90 minuten</option>
                </select>
              </div>
              <div data-id="element-847" data-mp="1fo43o7n0t2k8">
                <label htmlFor="deposit" className="text-sm font-medium text-chalk" data-id="element-848" data-mp="1fqq9o2u9ja0c">
                  Aanbetaling ({settings.depositPct}% van het totaal)
                </label>
                <input id="deposit" type="range" min={0} max={100} step={5} value={settings.depositPct} onChange={e => updateSettings({
                depositPct: Number(e.target.value)
              })} className="mt-3 w-full accent-[#ff6a2b]" data-id="element-849" data-mp="16ur1sg6zaqm0" />
              </div>
            </div>
          </section>

          <section className="rounded-2xl border border-edge bg-carbon p-5" data-id="element-850" data-mp="2zkteo4y2bh8t">
            <h2 className="text-xs uppercase tracking-[0.2em] text-dim" data-id="element-851" data-mp="2zmmeb0a9d17b">Geblokkeerde dagen</h2>
            {settings.blockedDates.length > 0 ? <ul className="mt-4 space-y-2" data-id="element-852" data-mp="38kyarixt2t7o">
                {[...settings.blockedDates].sort().map(iso => <li key={iso} className="flex items-center justify-between gap-3 rounded-xl border border-edge bg-panel px-4 py-3 text-sm" data-id="element-853" data-mp="3dhyhzx6e620d">
                      <span className="capitalize text-chalk" data-id="element-854" data-mp="2puqdhhgsewze">{longDate(iso)}</span>
                      <button type="button" onClick={() => toggleBlockedDate(iso)} aria-label={`Blokkade ${longDate(iso)} opheffen`} className="flex h-8 w-8 items-center justify-center rounded-full border border-edge text-dim transition-colors duration-200 ease-smooth hover:text-chalk" data-id="element-855" data-mp="2psnfaa5hdxjl">
                        <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-856" data-mp="vjo5zu4ttww2" />
                      </button>
                    </li>)}
              </ul> : <p className="mt-4 text-sm text-dim" data-id="element-857" data-mp="14jt2384kl8ux">
                Geen geblokkeerde dagen. Blokkeer vakantiedagen via de agenda.
              </p>}
            <p className="mt-4 text-xs text-dim" data-id="element-858" data-mp="1efnsipf1c889">
              Vandaag is {longDate(new Date().toISOString().slice(0, 10))} —{' '}
              {settings.blockedDates.includes(new Date().toISOString().slice(0, 10)) ? 'geblokkeerd' : 'open volgens schema'}
              .
            </p>
          </section>
        </div>
      </div>
    </div>;
}